import React from 'react';
import { AppInsightsContext, withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../../AppInsights';
import PrecertificationIntake from './precertificationIntake';
import TokenService from '../../services/Auth/TokenService';

const PrecertificationIntakeWrapper: React.FC = () => (
  <AppInsightsContext.Provider value={reactPlugin}>
    <PrecertificationIntake tokenService={new TokenService()} delay={900} runtime={36000} />
  </AppInsightsContext.Provider>
);
export default withAITracking(reactPlugin, PrecertificationIntakeWrapper);
